
const Skills = ({ skillsRef }) => {
  const skills = [
    "VueJS",
    "VueX",
    "NuxtJS",
    "ReactJS",
    "ReduxJS",
    "React-Context",
    "TypeScript",
    "JavaScript",
    "HTML/HTML5",
    "CSS/CSS3",
    "Sass",
    "Tailwind CSS",
    "Bootstrap",
    "Git & Github",
  ];

  return (
    <div ref={skillsRef} className="skills">
      <div className="wrapper" >
        <h2>Technical SKills</h2>
        <div className="skills-container">
          <div className='skillsWrapper' >
            {skills.map((skill, index) => (
              <span key={index} className="skill">
                {skill}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
